import { feedUpdates } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function FeedSection() {
  return (
    <section id="feed" className="w-full border-b border-background-200 bg-background-50">
      <div className="w-full px-4 py-14 md:px-8 md:py-16">
        <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <SectionHeading
            index="01"
            title="今日更新速览"
            desc="把最近的主题更新、榜单变化与合集上新压成短讯，标题在前、摘要在后，三十秒扫完当天的重点。"
          />
          <a
            href="#ranking"
            className="inline-flex w-fit cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:bg-primary-50"
          >
            查看完整排行
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </a>
        </div>

        <div className="mt-8 w-full rounded-lg border border-background-200 bg-background-50">
          {feedUpdates.map((item, index) => (
            <article
              key={item.title}
              className={`group flex cursor-pointer flex-col gap-3 px-4 py-4 transition-colors hover:bg-background-100 md:flex-row md:items-start md:gap-6 md:px-6 ${
                index !== feedUpdates.length - 1 ? "border-b border-background-200" : ""
              }`}
            >
              <div className="flex shrink-0 items-center gap-3 md:w-32 md:flex-col md:items-start md:gap-1.5">
                <span className="font-heading text-sm font-bold text-foreground-950">
                  {item.time}
                </span>
                <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-900">
                  {item.tag}
                </span>
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="font-heading text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-700">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
                  {item.summary}
                </p>
              </div>
              <span className="hidden h-8 w-8 shrink-0 items-center justify-center rounded-md bg-background-100 text-foreground-500 transition-colors group-hover:bg-primary-100 group-hover:text-primary-700 md:flex">
                <i className="ri-arrow-right-up-line text-base"></i>
              </span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}